// import { Composer, Container, MessageList, WebchatProvider, useClient } from "@botpress/webchat";
import { useEffect, useMemo, useState } from "react";
import { withRouter } from "react-router-dom";
import { SocialIcon } from "react-social-icons";
import { ScaleLoader } from "react-spinners";

import { Composer, Container, MessageList, useWebchat } from "@botpress/webchat";
import {
  AddComment,
  CheckBox,
  CheckBoxOutlineBlank,
  VolumeOff,
  VolumeUp,
} from "@mui/icons-material";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import MenuIcon from "@mui/icons-material/Menu";
import RecordVoiceOverIcon from "@mui/icons-material/RecordVoiceOver";
import VoiceOverOffIcon from "@mui/icons-material/VoiceOverOff";
import { Box, Typography } from "@mui/material";
import Divider from "@mui/material/Divider";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import MenuItem from "@mui/material/MenuItem";
import { useTheme } from "@mui/material/styles";

import { convertTextToSpeech } from "../../utils/googleTts.js";
import AppBarIconButton from "../ui/appBarIconButton";
import OmniAvatar from "../ui/omniAvatar.js";
import OmniMenu from "../ui/omniMenu";
import OmniResponsiveButton from "../ui/omniResponsiveButton";
import OmniTextToSpeechPlayer from "../ui/OmniTextToSpeechPlayer.js";
import Portal from "../ui/portal";

const SportsPortal = props => {
  const theme = useTheme();

  let webchatClientID = "1d9c1910-60da-4fa2-a237-89fd3122b711";

  //Flag Defs:
  //  languageCode - the code
  //  tts- bool

  //#region languageCode and TTS Parameter Handling
  const checkForLanguageCodeParam = () => {
    const urlParams = new URLSearchParams(window.location.search);
    for (var [key, value] of urlParams.entries()) {
      if (key === "languageCode") {
        return value;
      }
    }
    return "en-US";
  };
  const [languageCode] = useState(checkForLanguageCodeParam());

  const checkForTTSParam = () => {
    const urlParams = new URLSearchParams(window.location.search);
    for (var [key, value] of urlParams.entries()) {
      if (key === "tts") {
        return value === "true";
      }
    }
    return null;
  };
  const [ttsValue, setTTSValue] = useState(checkForTTSParam);

  useEffect(() => {
    if (ttsValue != null) {
      setIsWebchatOpen(true);
    }
  }, [ttsValue]);

  //#endregion

  const config = {
    botDescription: "Sports Celebrity Emulation",
    botName: "Isabella Echeverri",
    botAvatar:
      "https://omni-public-media.s3.us-west-2.amazonaws.com/branding/sportsAvatars/isa.jpg",
    title: "Celebrity Avatar",
    customColors: {
      commonGround: "#f9f9fb",
      primaryContrastText: "#EDEDEB",
      secondaryContrastText: "#FFFFFF",
      primaryColor: "#033241",
      secondaryColor: "#1E758D",
    },
    socialMedia: [
      "https://www.linkedin.com/in/isabellaecheverri",
      "https://www.instagram.com/isabellaecheverri11",
    ],
  };

  const [isWebchatOpen, setIsWebchatOpen] = useState(false);

  const { client, messages, isTyping, user, clientState, newConversation, on } = useWebchat({
    clientId: webchatClientID, // Insert your Client ID here
    storageKey: `botpress-sportsPortal-${webchatClientID}`,
    storageLocation: "localStorage",
  });

  const enrichedMessages = useMemo(
    () =>
      messages.map(message => {
        const { authorId } = message;
        const direction = authorId === user?.userId ? "outgoing" : "incoming";
        return {
          ...message,
          direction,
          sender:
            direction === "outgoing"
              ? { name: user?.name ?? "You", avatar: user?.pictureUrl }
              : { name: config.botName ?? "Bot", avatar: config.botAvatar },
        };
      }),
    [config.botAvatar, config.botName, messages, user?.userId, user?.name, user?.pictureUrl],
  );

  //#region User Data Update
  const [userInitialized, SetUserInitialized] = useState(false);

  useEffect(() => {
    if (client && !userInitialized) {
      try {
        client.updateUser({
          data: { languageCode: languageCode },
        });
        SetUserInitialized(true);
      } catch (error) {
        console.error(error);
      }
    }
  }, [client, userInitialized, languageCode]);
  //#endregion

  //#region Menu HandlersOmni Header
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  //#endregion

  //#region Text to Speech Player Handlers

  const [volume, setVolume] = useState(0.5);
  const [textToSpeechQueue, setTextToSpeechQueue] = useState([]);

  const [speechConfig] = useState({
    voiceName: "Despina",
    languageCode: "es-US",
    speakingRate: 1.135,
  });

  useEffect(() => {
    const unsubscribe = on("message", message => {
      if (message.authorId !== user?.userId) {
        try {
          let messageText = message.block.block.text;
          convertTextToSpeech(messageText, speechConfig).then(url => {
            setTextToSpeechQueue(prev => [...prev, url]);
          });
        } catch (error) {
          console.error("Error in TTS message handling:", error);
        }
      }
    });

    return () => {
      unsubscribe?.();
    };
  }, [on, speechConfig, user]);

  // useEffect(() => {
  //   const thusSpokeZarathustra = async (message, speechConfig) => {
  //     try {
  //       console.info("adding URL", message);
  //       convertTextToSpeech(message, speechConfig).then(url => {
  //         console.info("here's your blob", url);
  //         setTextToSpeechQueue(prev => [...prev, url]);
  //       });
  //     } catch (error) {
  //       console.error("Error generating text-to-speech URL:", error);
  //     }
  //   };

  //   if (message && textToSpeechEnabled && speechConfig) {
  //     thusSpokeZarathustra(message, speechConfig);
  //     // setMessage(null);
  //   }
  // }, [message, textToSpeechEnabled, speechConfig, setMessage, setTextToSpeechQueue]);

  //#endregion

  return (
    <Portal
      displayHeader={false}
      sx={{
        backgroundSize: "cover",
        border: "none",
      }}
    >
      {isWebchatOpen === false && (
        <Box
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            flexGrow: 1,
            border: "none",
            margin: 0,
            padding: 0,
            minWidth: "100%",
            height: "100%",
            backgroundColor: "transparent",
          }}
        >
          <Box
            sx={{
              position: "absolute",
              top: "calc(50vh - 150px)",
              left: "calc(50vw - 150px)",
              flexGrow: 1,
              border: "none",
              margin: 0,
              padding: 0,
              backgroundColor: "transparent",
              display: "flex",
              flexDirection: "column",
              maxWidth: "300px",
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                marginBottom: theme.spacing(1),
                maxWidth: "300px",
                textAlign: "center",
                justifyContent: "space-evenly",
              }}
            >
              <Typography variant="h4" sx={{ textAlign: "center" }}>
                Multimedia
              </Typography>
              <ScaleLoader />
            </Box>
            <Typography variant="h6" sx={{ textAlign: "center", marginBottom: theme.spacing(1) }}>
              This experience includes spoken responses in Isa's voice.
            </Typography>

            <OmniResponsiveButton
              icon={<VolumeUp />}
              onClick={() => {
                setTTSValue(true);
              }}
              buttonText={"Full Experience"}
              tooltipTitle="Hear Isa's AI Emulated Voice read responses aloud."
              varient="contained"
              tooltipPlacement="top"
            />
            <Divider sx={{ marginTop: theme.spacing(2), marginBottom: theme.spacing(2) }} />
            <Typography variant="h6" sx={{ textAlign: "center", marginBottom: theme.spacing(1) }}>
              Need to keep it quiet?
            </Typography>
            <OmniResponsiveButton
              icon={<VolumeOff />}
              onClick={() => {
                setTTSValue(false);
              }}
              buttonText={"No Sound"}
              tooltipTitle="Disable the Audio Portion of this Experience."
              tooltipPlacement="top"
            />
          </Box>
        </Box>
      )}

      {isWebchatOpen === true && (
        <Container
          connected={clientState !== "disconnected"}
          style={{
            height: "100vh",
            display: isWebchatOpen ? "flex" : "none",
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              border: "none",
              boxShadow: theme.shadows[2],
              zIndex: 1,
              columnGap: "8px",
              paddingTop: "12px",
              paddingBottom: "12px",
              paddingLeft: "16px",
              paddingRight: "16px",
              backgroundColor: `${config.customColors.primaryColor}dd`,
            }}
          >
            <OmniAvatar
              sx={{
                width: "64px",
                height: "64px",
                boxShadow: theme.shadows[2],
                background: "radial-gradient(#fdfef400, #aaaaaa)",
              }}
              src={config.botAvatar}
            />
            <Box
              sx={{
                flexGrow: 1,
                display: "flex",
                flexDirection: "column",
                color: config.customColors.primaryContrastText,
              }}
            >
              <Typography
                variant="h5"
                fontWeight={"500"}
                sx={{ textShadow: `1px 1px 1px ${config.customColors.secondaryContrastText}88` }}
              >
                {config.botName.split(" ")[0]}
              </Typography>
              <Typography
                variant="subtitle1"
                sx={{
                  marginTop: "-6px",
                }}
              >
                {config.botName.split(" ")[1]}
              </Typography>
            </Box>
            {config && config.socialMedia ? (
              <Box display={"flex"} columnGap={"0px"} color="inherit">
                {config.socialMedia.map(social => (
                  <AppBarIconButton>
                    <SocialIcon
                      target="_blank"
                      url={social}
                      bgColor="transparent"
                      style={{ height: 36, width: 36 }}
                    />
                  </AppBarIconButton>
                ))}
              </Box>
            ) : null}
            <Box
              style={{
                color: config.customColors.primaryContrastText,
              }}
            >
              <AppBarIconButton
                size="large"
                edge="start"
                color="inherit"
                id="omni-primary-menu-button"
                onClick={e => handleClick(e)}
              >
                {!open ? <MenuIcon /> : <CloseRoundedIcon />}
              </AppBarIconButton>

              <OmniMenu
                id="omni-primary-menu"
                MenuListProps={{
                  "aria-labelledby": "omni-primary-menu-button",
                }}
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
              >
                <MenuItem
                  component="label"
                  onClick={() => {
                    setTTSValue(!ttsValue);
                    handleClose();
                  }}
                >
                  <ListItemIcon>
                    {!ttsValue && <RecordVoiceOverIcon fontSize="small" />}
                    {ttsValue && <VoiceOverOffIcon fontSize="small" />}
                  </ListItemIcon>
                  <ListItemText>{ttsValue ? "Turn off Audio" : "Listen To Audio"}</ListItemText>
                </MenuItem>

                <Divider
                  sx={{
                    display: "flex",
                  }}
                />

                <MenuItem
                  component="label"
                  onClick={() => {
                    handleClose();
                  }}
                >
                  <ListItemIcon>
                    <CheckBox fontSize="small" />
                  </ListItemIcon>
                  <ListItemText>{"Isabella Echeverri"}</ListItemText>
                </MenuItem>

                <Divider
                  sx={{
                    display: "flex",
                  }}
                />

                <MenuItem
                  component="label"
                  onClick={() => {
                    handleClose();
                    const path = `/avatars?tts=${ttsValue}&languageCode=en-US`;
                    props.history.push(path);
                    props.history.go();
                  }}
                >
                  <ListItemIcon>
                    {languageCode.startsWith("en") && <CheckBox fontSize="small" />}
                    {!languageCode.startsWith("en") && <CheckBoxOutlineBlank fontSize="small" />}
                  </ListItemIcon>
                  <ListItemText>{"English (US)"}</ListItemText>
                </MenuItem>

                <MenuItem
                  component="label"
                  onClick={() => {
                    handleClose();
                    const path = `/avatars?tts=${ttsValue}&languageCode=es-CO`;
                    props.history.push(path);
                    props.history.go();
                  }}
                >
                  <ListItemIcon>
                    {languageCode.startsWith("es") && <CheckBox fontSize="small" />}
                    {!languageCode.startsWith("es") && <CheckBoxOutlineBlank fontSize="small" />}
                  </ListItemIcon>
                  <ListItemText>{"Spanish (CO)"}</ListItemText>
                </MenuItem>

                <MenuItem
                  component="label"
                  onClick={() => {
                    handleClose();
                    const path = `/avatars?tts=${ttsValue}&languageCode=fr-FR`;
                    props.history.push(path);
                    props.history.go();
                  }}
                >
                  <ListItemIcon>
                    {languageCode.startsWith("fr") && <CheckBox fontSize="small" />}
                    {!languageCode.startsWith("fr") && <CheckBoxOutlineBlank fontSize="small" />}
                  </ListItemIcon>
                  <ListItemText>{"French (FR)"}</ListItemText>
                </MenuItem>

                <MenuItem
                  component="label"
                  onClick={() => {
                    handleClose();
                    const path = `/avatars?tts=${ttsValue}&languageCode=pt-BR`;
                    props.history.push(path);
                    props.history.go();
                  }}
                >
                  <ListItemIcon>
                    {languageCode.startsWith("pt") && <CheckBox fontSize="small" />}
                    {!languageCode.startsWith("pt") && <CheckBoxOutlineBlank fontSize="small" />}
                  </ListItemIcon>
                  <ListItemText>{"Portuguese (BR)"}</ListItemText>
                </MenuItem>

                <Divider
                  sx={{
                    display: "flex",
                  }}
                />

                <MenuItem
                  onClick={() => {
                    handleClose();
                    newConversation();
                  }}
                >
                  <ListItemIcon>
                    <AddComment fontSize="small" />
                  </ListItemIcon>
                  <ListItemText>New Conversation</ListItemText>
                </MenuItem>
              </OmniMenu>
            </Box>
          </Box>

          <MessageList
            botAvatar={config.botAvatar}
            botName={config.botName}
            botDescription={config.botDescription}
            isTyping={isTyping}
            headerMessage="Chat History"
            showMarquee={true}
            messages={enrichedMessages}
            sendMessage={client?.sendMessage}
            // renderers={{
            //   bubble: props => {
            //     console.log("props", props);
            //
            //     return <div> {props.text} </div>;
            //   },
            // }}
          />
          <Composer
            disableComposer={false}
            isReadOnly={false}
            allowFileUpload={true}
            connected={clientState !== "disconnected"}
            sendMessage={client?.sendMessage}
            uploadFile={client?.uploadFile}
            composerPlaceholder="Type a message..."
          />
          {ttsValue === true && (
            <Box
              style={{
                position: "absolute",
                right: 58,
                bottom: 21,
                zIndex: 1001,
                height: 32,
                width: 32,
                color: "#5f6276",
              }}
            >
              <OmniTextToSpeechPlayer
                textToSpeechQueue={textToSpeechQueue}
                setTextToSpeechQueue={setTextToSpeechQueue}
                volume={volume}
                setVolume={setVolume}
              />
            </Box>
          )}
        </Container>
      )}
    </Portal>
  );
};

export default withRouter(SportsPortal);
